import { Banner, Button, Flex, Text } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

import { ExternalLink } from '@common';

import { useGlobalUI } from '@/components/GlobalUIProvider';
import ABMModal from '@/components/ABMManagement/ABMModal';
import { getLocalizedAppleUrl } from '@/helpers/getLocalizedAppleUrl';

const UnknownMessage = () => {
  const { t } = useTranslation('getting-started');
  const { openModal, closeModal } = useGlobalUI();
  return (
    <Text>
      {t('abmUnknownBanner.message')}
      <Flex columnGap="2rem" alignItems="center" mt="1rem">
        <ExternalLink
          id="abm-unknown-banner-learn-more-apple-link"
          href={getLocalizedAppleUrl(
            'https://support.apple.com/guide/apple-business-manager/manage-device-suppliers-axmef1c47493/web'
          )}>
          {t('abmUnknownBanner.learnMore')}
        </ExternalLink>
        <Button
          variant="outline"
          intent="danger"
          onClick={() => openModal(<ABMModal onClose={closeModal} />)}
          id="abm-unknown-banner-resolve-issue">
          {t('abmUnknownBanner.resolveButton')}
        </Button>
      </Flex>
    </Text>
  );
};

const ABMUnknownBanner = () => {
  const { t } = useTranslation('getting-started');
  return (
    <Banner
      id="abm-unknown-banner"
      isFlat
      intent="error"
      title={t('abmUnknownBanner.title')}
      message={() => <UnknownMessage />}
    />
  );
};

export default ABMUnknownBanner;
